import { render, staticRenderFns } from "./ProcessQueue.vue?vue&type=template&id=65864c49&scoped=true"
import script from "./ProcessQueue.vue?vue&type=script&lang=js"
export * from "./ProcessQueue.vue?vue&type=script&lang=js"
import style0 from "./ProcessQueue.vue?vue&type=style&index=0&id=65864c49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65864c49",
  null
  
)

export default component.exports